// Generated from the runtime DOM of req/web-app.html after prototype initialization.
// Keep this as visual template data; interactions live in PrototypeController.
import { shellMarkup } from "./markup/shellMarkup";
import { homeMarkup } from "./markup/homeMarkup";
import { browseMarkup } from "./markup/browseMarkup";
import { topicMarkup } from "./markup/topicMarkup";
import { articleMarkup } from "./markup/articleMarkup";
import { profileViewMarkup } from "./markup/profileMarkup";
import { historyMarkup } from "./markup/historyMarkup";
import { pricingMarkup } from './markup/pricingMarkup';
import { membershipBillingMarkup } from './markup/membershipBillingMarkup';
import { feedbackMarkup } from "./markup/feedbackMarkup";
import { ideaDetailMarkup } from "./markup/ideaDetailMarkup";
import { aiJobDetailMarkup } from "./markup/aiJobDetailMarkup";
import { aiCreateMarkup } from "./markup/aiCreateMarkup";
import { socialMarkup } from "./markup/socialMarkup";
import { communityMarkup } from "./markup/communityMarkup";
import { githubTrendingMarkup } from "./markup/githubTrendingMarkup";
import { modalMarkups } from "./markup/modalMarkups";
import { referralCenterMarkup } from './markup/referralCenterMarkup';
import { messagesPageMarkup } from './markup/messagesPageMarkup';
import { redeemMarkup } from './markup/redeemMarkup';

/**
 * The view and overlay fragments are joined into a single string and
 * rendered into <body> by bootstrapApp.ts (Mode B).
 *
 * DOM tree (mirrors req/web-app.html):
 *   <body>
 *     [shellMarkup]               -- <nav.top-nav> + mobile navigation
 *     <div class="app-layout has-player">
 *       <main class="app-main">
 *         [homeMarkup .. aiCreateMarkup] -- the view containers
 *         [socialMarkup]                 -- the mobile social aggregate
 *         [communityView + githubView]  -- the PC top-level Community / GitHub Trending pages
 *       </main>
 *     </div>
 *     [playerMarkup]              -- web-player + video-fullscreen
 *     [paywallMarkup]             -- paywall modal
 *     [ideaModalMarkup]           -- submit-idea wizard
 *     [aiCreateModalMarkup]       -- ai-create wizard
 *     [successModalsMarkup]       -- ai/idea success toasts
 *     Credential forms are deliberately absent at rest. The existing Dialog
 *     overlays are mounted one at a time while open and removed when closed.
 *
 * Per AGENTS.md §6: PC keeps its dedicated Community / GitHub Trending
 * top-level pages — the mobile Social aggregate (`#view-social`) is
 * additive, not a replacement. PC and mobile render named instances from
 * the same Community / GitHub Trending component builders; only the PC
 * instances are wrapped in `<div class="view" id="...">`
 * so `showView('community')` / `showView('github-trending')` resolve
 * distinct top-level views while mobile still uses the
 * `#view-social` aggregate entry path.
 *
 * Structural rule (audited by viewStructureAudit): every direct child
 * of <main class="app-main"> MUST be a `.view` container. Anything else
 * (nav, player, modals) lives outside <main> so the CSS
 * mask `main.app-main > *:not(.view) { display: none !important }`
 * never has to hide structural noise.
 */
const communityView = `<div class="view" id="view-community">${communityMarkup}</div>`;
const githubTrendingView = `<div class="view" id="view-github-trending">${githubTrendingMarkup}</div>`;

export const prototypeMarkup =
  shellMarkup +
  '<div class="app-layout has-player"><main class="app-main">' +
  [
    homeMarkup,
    browseMarkup,
    topicMarkup,
    articleMarkup,
    socialMarkup,
    communityView,
    githubTrendingView,
    pricingMarkup,
    profileViewMarkup,
		membershipBillingMarkup,
    historyMarkup,
    feedbackMarkup,
    ideaDetailMarkup,
    aiJobDetailMarkup,
    aiCreateMarkup,
    referralCenterMarkup,
    messagesPageMarkup,
		redeemMarkup,
  ].join("") +
  "</main></div>" +
  modalMarkups.join("");
